class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
      // this.fetchRecommendations()
      //   .then(nothing => this.fetchRecommendations()).then(nothing => this.fetchRecommendations()).then(() => alert("next"));
    this.renderLimit = parseInt(this.dataset.renderLimit);
    this.wrapperClass = this.dataset.wrapperClass;
    this.massDrawer = this.closest("mass-drawer");
    this.parsedElementsToRender = [];
    this.fetchedUrls = [];
  }

  connectedCallback() {
    console.log(`%c[MassTech / Product Recommendations]  url: ${this.dataset.url}`, "color: Chocolate");
    this.handleRenderLimit();
  }

  renderRecommendations(recommendations, inner = true) {
      // const recommendations = getSectionInnerHTML(text, 'product-recommendations');
      // console.log("recommendations :" + recommendations);
      if (recommendations && recommendations.trim().length) {
        inner ? this.innerHTML = recommendations : this.outerHTML = recommendations;
        // alert(getSectionInnerHTML(recommendations.trim(), ".card-information__text").innerHTML);
      }

    return;
  }

  wrapSectionOuter(parsedSection, selector) {
    parsedSection.querySelector(selector).outerHTML = `<div class="${this.wrapperClass}">` + parsedSection.querySelector(selector).outerHTML + `</div>`;
    return parsedSection;
  }

  getWrappedSectionOuter(parsedSection, selector) {
    const wrappedSection = this.wrapSectionOuter(parsedSection, selector).querySelector(selector);
    wrappedSection.setAttribute("inserted", "");
    return wrappedSection.outerHTML;
  }
  wrapSectionInner(parsedSection, selector) {
    parsedSection.querySelector(selector).innerHTML = `<div class="${this.wrapperClass}">` + parsedSection.querySelector(selector).innerHTML + `</div>`;
    // console.log("parsedSection.querySelector(selector).innerHTML = "+ parsedSection.querySelector(selector).innerHTML);
    return parsedSection;
  }

  getWrappedSectionInner(parsedSection, selector) {
    // const wrappedParsedSection = this.wrapSectionInner(parsedSection, selector);
    // const wrappedSection = wrappedParsedSection.querySelector(selector);
    // const wrapperSection = wrappedParsedSection.querySelector(`.${this.wrapperClass}`);
    // wrapperSection.className += (" " + (wrappedSection.className));
    // const wrappedSectionInner = wrapperSection.outerHTML;
    // console.log("wrappedSectionInner: " + wrappedSectionInner);
    // return wrappedSectionInner;

    return this.wrapSectionInner(parsedSection, selector).querySelector(selector).innerHTML;
  }

  replaceElementTag(parsedSection, selector) {

  }

  reduceRecommendations(text, parsedElements) {
    var parsedSection_renderLimitNoWrap = new DOMParser().parseFromString(text, 'text/html');
    parsedSection_renderLimitNoWrap.querySelector(".product-grid").innerHTML = "";

    var parsedSection_toBeWrapped = new DOMParser().parseFromString(text, 'text/html');
    var parsedSection_renderLimitWithWrap = "";

    parsedElements.forEach((parsedElement) => {
      parsedSection_renderLimitNoWrap.querySelector(".product-grid").innerHTML += parsedElement.outerHTML;
      if (this.wrapperClass) {
        parsedSection_toBeWrapped = new DOMParser().parseFromString(text, 'text/html');
        parsedSection_toBeWrapped.querySelector(".product-grid").innerHTML = parsedElement.outerHTML;
        parsedSection_renderLimitWithWrap += this.getWrappedSectionInner(parsedSection_toBeWrapped, "product-recommendations");
      }
    });

      this.wrapperClass ? this.renderRecommendations(parsedSection_renderLimitWithWrap, false) : 
                      this.renderRecommendations(parsedSection_renderLimitNoWrap.querySelector("product-recommendations").innerHTML);
  }
  async buildElementsToRender(text) {
    const parsedElementsAll = this.getSectionElements(text, ".product-recommendations__item");
    for (let parsedElement of parsedElementsAll) {
      // console.log(parsedElement.innerHTML);
      if ((this.parsedElementsToRender.length < this.renderLimit) && !(this.massDrawer.recommendations.ids.includes(parsedElement.dataset.productid)) &&
        !(this.massDrawer.items.ids.includes(parsedElement.dataset.productid))) {
          this.parsedElementsToRender.push(parsedElement);
          this.massDrawer.recommendations.ids.push(parsedElement.dataset.productid);
      }
    }
    for (let parsedElement of parsedElementsAll) {
      if ((this.parsedElementsToRender.length < this.renderLimit) && !(this.massDrawer.items.ids.includes(parsedElement.dataset.productid))) {
        if( !(  this.fetchedUrls.includes(this.customFetchUrl(parsedElement.dataset.productid))  )  ) {
          this.buildElementsToRender(await this.fetchRecommendations(parsedElement.dataset.productid));
          console.log("second loop :( fetching new? =[");
        } 
      }
    }
    if(this.parsedElementsToRender.length < this.renderLimit) {
      for (let recommendationId of this.massDrawer.recommendations.ids) {
        console.log("i'm in the third loop bro, send help.");
        if (!(this.fetchedUrls.includes(this.customFetchUrl(recommendationId)))) {
          this.buildElementsToRender(await this.fetchRecommendations(recommendationId));
          console.log("trying third loop!! there's no more items HEEELP!!!");
        }
      }
    }
    return this.parsedElementsToRender;
  }
  async applyRenderLimit(text) {
    
    return this.reduceRecommendations(text, await this.buildElementsToRender(text));
  }
  async handleRenderLimit() {
    this.renderLimit ? await this.applyRenderLimit( await this.fetchRecommendations()) : this.renderRecommendations(getSectionInnerHTML(await this.fetchRecommendations(), 'product-recommendations'));
  }
  customFetchUrl(productId) {
    const url_from_product_id = this.dataset.url.slice(this.dataset.url.indexOf("product_id"));
    return  this.dataset.url.slice(0,  this.dataset.url.indexOf("product_id") + url_from_product_id.indexOf("=") + 1) + 
            productId + 
            this.dataset.url.slice(this.dataset.url.indexOf("product_id") + url_from_product_id.indexOf("&"));
  }
  fetchRecommendations(customProductId) {
    const fetchUrl = customProductId ? this.customFetchUrl(customProductId) : this.dataset.url;    
    return fetch(fetchUrl)
    .then(response => {
      this.fetchedUrls.push(fetchUrl);
      return response.text();
      })
    .catch(e => {
      console.error(e);
    });
  }

  getSectionElements(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelectorAll(selector);
  }
}

customElements.define('product-recommendations', ProductRecommendations);